import { Model } from "./model";
import { Permission } from "app/shared/models/permission.interface";

/**
 * The class represents a Permissions Model
 */
export class Permissions extends Model {
  // The following names are defined by the API return value.
  // tslint:disable:variable-name
  public client_login: boolean = false;
  public client_mobile_pack_contract_type_mini_mouse: boolean = false; // Mobility option
  public admin_login: boolean = false;
  public admin_login_inherited: boolean = false;

  public setAttributes(permissionData: Permission[]): void {
    permissionData.forEach((permission: Permission) => {
      switch (permission.roleName) {
        case "zebra.admin.login": {
          this.admin_login = true;
          this.admin_login_inherited =
            permission.account_id !== permission.parent_account_id;
          break;
        }
        case "zebra.client.mobile_pack.contract_type_mini_mouse": {
          this.client_mobile_pack_contract_type_mini_mouse = true;
          break;
        }
      }
    });
  }

  public fromForm(json: any): void {
    this.client_mobile_pack_contract_type_mini_mouse =
      json.client_mobile_pack_contract_type_mini_mouse;
    this.admin_login = json.admin_login;
  }

  public fromJSON(json: any): void {
    this.setAttributes(json);
  }

  /**
   * Check out the difference in permissions settings before and after changes
   */
  public getDiff(perm: Permissions): any {
    const ret: any = {};

    if (
      this.client_mobile_pack_contract_type_mini_mouse !== undefined &&
      this.client_mobile_pack_contract_type_mini_mouse !==
        perm.client_mobile_pack_contract_type_mini_mouse
    ) {
      ret.client_mobile_pack_contract_type_mini_mouse =
        this.client_mobile_pack_contract_type_mini_mouse;
    }

    if (
      this.admin_login !== undefined &&
      this.admin_login !== perm.admin_login
    ) {
      ret.admin_login = this.admin_login;
    }

    return ret;
  }
}
